<p-fieldset styleClass="mt-2">
    <ng-template pTemplate="header">
        <div class="d-flex">
            <fa-icon [icon]='["far","file-contract"]'></fa-icon>
            <div class="mx-2">
                Terms and Conditions
            </div>
            <div class="ms-auto">
                <fa-icon [icon]='["far","question-circle"]' (click)="displayModal.emit('terms')"></fa-icon>
            </div>
        </div>
    </ng-template>
    <app-focuspay-terms-and-conditions></app-focuspay-terms-and-conditions>
</p-fieldset>